import React from 'react';

interface ShareOptionsProps {
    copied: boolean;
    onKakaoShare: () => void;
    onSMSShare: () => void;
    onLinkShare: () => void;
    onCopyText: () => void;
}

export const ShareOptions: React.FC<ShareOptionsProps> = ({
    copied,
    onKakaoShare,
    onSMSShare,
    onLinkShare,
    onCopyText
}) => {
    return (
        <div className="share-options">
            <h3 className="options-title">공유 방법</h3>

            <div className="options-grid">
                <button className="share-option-button" onClick={onKakaoShare}>
                    <div className="option-icon" style={{ backgroundColor: '#FEE500' }}>
                        💬
                    </div>
                    <div className="option-label">카카오톡</div>
                </button>

                <button className="share-option-button" onClick={onSMSShare}>
                    <div className="option-icon" style={{ backgroundColor: '#4CAF50' }}>
                        💬
                    </div>
                    <div className="option-label">문자</div>
                </button>

                <button className="share-option-button" onClick={onLinkShare}>
                    <div className="option-icon" style={{ backgroundColor: '#2196F3' }}>
                        🔗
                    </div>
                    <div className="option-label">링크 복사</div>
                </button>

                <button className="share-option-button" onClick={onCopyText}>
                    <div className="option-icon" style={{ backgroundColor: '#FF9800' }}>
                        📋
                    </div>
                    <div className="option-label">텍스트 복사</div>
                </button>
            </div>

            {copied && (
                <div className="copy-toast">
                    ✓ 클립보드에 복사되었어요
                </div>
            )}
        </div>
    );
};
